import { ApolloQueryResult } from 'apollo-client';

import { findAndReplaceKeywordsPreview } from '../../graphql/queries/grid/common';
import {
    FindAndReplaceKeywordsPreview,
    GdFindAndReplaceKeywordsInput
} from '../../typings/graphql-grid';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export const previewLimitOffset = {
    limit: 60,
    offset: 0
};

export class PhrasesWizardDataProvider extends BaseDataProvider {
    public findAndReplaceKeywordsPreview(
        input: GdFindAndReplaceKeywordsInput,
        login: string
    ): Promise<FindAndReplaceKeywordsPreview> {
        input.limitOffset = previewLimitOffset;

        return this.createQuery<FindAndReplaceKeywordsPreview>(
            findAndReplaceKeywordsPreview,
            {
                variables: {
                    input,
                    login
                }
            }
        ).then(
            (result: ApolloQueryResult<FindAndReplaceKeywordsPreview>) =>
                result.data
        );
    }
}
